<template>
  <div id="singleBetSlip">
    <!--dialogSingleBetslip (comp): {{dialogSingleBetslip}}-->
    <!--selection: {{selection}}-->
    <!--currentBetSlipState: {{currentBetSlipState}}<br>-->
    <!--betSlipStatus: {{betSlipStatus}}<br>-->

    <!--<v-btn :disabled="currentBetSlipState>0" class="btn primary-button primary-btn" @click="addToBetSlip()">Add to BetSlip</v-btn>-->
    <!--<button :disabled="currentBetSlipState>0" class="btn" @click="cancelDialog()"> X </button>-->

    <div v-if="selection" class="bsSelection"
         :class="[{
    priceUp: (priceUp && !(isclosed || issuspended || isNr)),
    priceDown: (priceDown && !(isclosed || issuspended || isNr)),
    isClosed: isclosed,
    isSuspended: issuspended,
    isNR: isNr,
    hcpUp: hcpUp,
    hcpDown: hcpDown,
    edit: currentBetSlipState==0,
    review: currentBetSlipState==1,
    changed: !isclosed && !issuspended && !isNr && (priceUp || priceDown || hcpUp || hcpDown)
         }]" >
      <!--@mousedown="start" @mouseleave="stop" @mouseup="stop" @touchstart="start" @touchend="stop" @touchcancel="stop"-->

      <div class="selection-data">

        <div class="columns">
          <div class="column column-left" >
            <button class="btnX" @click="cancelDialog()"
                :disabled="!(currentBetSlipState<1 || betSlipStatus.State==4 || (currentBetSlipState == 6 && betSlipStatus.State == 1))">
              <icon name="icon-trash" colorName="red"></icon>
            </button>
          </div>


          <div class="column column-right" >

            <label :for="id">

              <div class="selection-data">

                <div class="selection-name">
                    <span class="name">
                      {{ formatSelectionName(selection) }}
                     <span class="currenthandicap" v-if="selection && selection.currenthandicap">{{ formatHandicap(selection)}}</span>
                    </span>

                  <div class="selection-price"  >
                    <b class="price">
                      <span >{{ formatSelectionPrice(selection)}}</span>
                    </b>
                    <span class="lock" v-show="isclosed || issuspended || isNr">
                        <span v-if="isclosed">{{ $t('BetSlip.selection.isClosed') }}</span>
                        <span v-if="issuspended">{{ $t('BetSlip.selection.isSuspended') }}</span>
                        <span v-if="isNr">{{ $t('BetSlip.selection.isNr') }}</span>
                      </span>
                  </div>

                </div>

                <div class="market-name" >{{market.name}}</div>

              </div>

            </label>
          </div>

        </div>
      </div>


      <div class="header-changed msg info" v-if="changed && currentBetSlipState<1">
        <icon name="icon-information" colorName="blue"></icon>
        <span>
          <span v-if="priceUp">{{ $t('BetSlip.selection.changed.priceUp') }}</span>
          <span v-if="priceDown">{{ $t('BetSlip.selection.changed.priceDown') }}</span>
          <span v-if="hcpUp">{{ $t('BetSlip.selection.changed.hcpUp') }}</span>
          <span v-if="hcpDown">{{ $t('BetSlip.selection.changed.hcpDown') }}</span>
        </span>
      </div>

      <div class="betPlacement" v-show="!isGeolocated && isLoggedIn" >
        <div class="messages align-center" v-if="geolocationMessage.errorCode" >
            <!--isOpenedFromWebView: {{isOpenedFromWebView}}<br>-->
            <!--mobileBigAndBelow: {{mobileBigAndBelow}}<br>-->
            <!--isGeolocated: {{isGeolocated}}<br>-->
            <!--geolocationMessage: {{geolocationMessage}}<br>-->
            <!--geolocationMessage.errorCode: {{geolocationMessage.errorCode}}<br>-->
        <!--<div v-if="!isOpenedFromWebView && !mobileBigAndBelow" class="align-center">-->
             <div class="not-geolocated"  >
               <div :key="geolocationMessage.errorCode + '-' + Math.random()" v-if="geolocationMessage.errorCode === 'verify'">
                 <p class="pls-wait">{{ $t('BetSlip.pleaseWait') }}</p>
                 <p class="verify" >{{ $t('BetSlip.VerifyingLocation') }}</p>
                 <div class="loader-container">
                   <circle-loader></circle-loader>
                 </div>
               </div>
               <div :key="geolocationMessage.errorCode + '-' + Math.random()" v-if="(geolocationMessage.errorCode === 999 || geolocationMessage.errorCode === 612) || (errorMsgLocalStorage === '999' || errorMsgLocalStorage === '612')">
                 <p>{{ $t('BetSlip.notLocated.' + state) }}</p>
                 <p>{{ $t('BetSlip.tryAgain.' + state) }}</p>
               </div>
             </div>
        <!--</div>-->
        </div>
      </div>

      <div class="betPlacement" v-if="currentBetSlipState>1">
        <div class="messages" :class="{'loader' : currentBetSlipState==2 || currentBetSlipState==3 || currentBetSlipState==4}">

          <div v-if="currentBetSlipState==3 && inRefferal" class="align-center messages">
            <h3 >
              <span>
                {{ $t('BetSlip.status.acceptable.referred.reOffered') }}
              </span>
            </h3>

            <div class="msg info" :class="{'inRefferal':inRefferal}">
              <span>{{ $t('BetSlip.betPlacementStatus.Status.detailed.referred.reOffered') }}</span>
            </div>
          </div>

          <div v-if="currentBetSlipState==5" class="align-center">
            <!--
            <div v-if="false && betSlipStatus.State==2">
              <div>Bet Placed</div>
            </div>
            -->

            <div v-if="betSlipStatus.State==4" >
              <h3>
                <span v-if="!errorType">
                  {{ $t('BetSlip.status.rejected') }}
                </span>
                <span v-else>
                  {{ $t('BetSlip.placement.error.' + errorType + '.result' ) }}
                </span>
              </h3>
              <div class="errorMsg reject-reason" v-if="betPlacementResult.Status.StatusText">
                <span v-html="betPlacementResult.Status.StatusText"></span>
              </div>
            </div>

            <div v-if="betSlipStatus.State==5">
              <h3>
                <span v-if="inRefferal">{{ $t('BetSlip.status.waiting.reffer') }}</span>
                <span v-else >{{ $t('BetSlip.status.waiting') }}</span>
              </h3>

              <div v-for="reason in betPlacementResult.Status.detailedStates">
                <span>{{ $t('BetSlip.betPlacementStatus.Status.detailed.' + reason) }}</span>
                <span v-if="reason==='reOffered'"><strong>$ {{betPlacementResult.result.TotalStake.toFixed(2)}}</strong></span>
              </div>
            </div>

          </div>

          <div v-if="currentBetSlipState==6" class="align-center">
            <h3 v-if="betSlipStatus.State==1" class="Bet-Acceptable">
            <span v-if="betPlacementResult.Status.detailedStates && betPlacementResult.Status.detailedStates.indexOf('reOffered')>-1">
              <span v-if="inRefferal">{{ $t('BetSlip.status.acceptable.referred.reOffered') }}</span>
              <span v-else >{{ $t('BetSlip.status.acceptable.reOffered') }}</span>
            </span>
              <span v-else>{{ $t('BetSlip.status.acceptable') }}</span>
            </h3>
            <h3 v-if="betSlipStatus.State==3" class="Bet-Reoffered">
            <span v-if="betPlacementResult.Status.detailedStates && betPlacementResult.Status.detailedStates.indexOf('reOffered')>-1">
              {{ $t('BetSlip.status.reoffered.reOffered') }}
            </span>
              <span v-else>{{ $t('BetSlip.status.acceptable') }}</span>
            </h3>
            <div class="msg info" :class="{'inRefferal':inRefferal}">
              <div v-for="reason in betPlacementResult.Status.detailedStates">
                <span v-if="inRefferal">{{ $t('BetSlip.betPlacementStatus.Status.detailed.referred.' + reason) }}</span>
                <span v-else>{{ $t('BetSlip.betPlacementStatus.Status.detailed.' + reason) }}</span>
              </div>
            </div>

          </div>

          <div v-if="currentBetSlipState==7" class="align-center">
            <h3>{{ $t('BetSlip.status.canceled') }}</h3>
          </div>
          <div v-if="currentBetSlipState==8" class="align-center">
            <h3>{{ $t('BetSlip.status.timedOut') }}</h3>
          </div>


          <div v-if="currentBetSlipState==9 || showError" class="align-center">
            <!--errorId: {{errorId}}<br>-->
            <!--errorMsg: {{errorMsg}}<br>-->
            <div v-if="errorMsg" class="errorMsg" :class="errorId" >
              <span class="pd-icon pd-icon-dp-info"></span>
              <span class="message" v-html="$t('BetSlip.placement.error.' + errorId, {uiView: this.isOpenedFromWebView ? '?uiView=true' : ''})"></span>
            </div>
            <div v-else class="errorMsg" >
              <!-- <icon name="icon-information" colorName="white"></icon> -->
              <span class="pd-icon pd-icon-dp-info"></span>
              <span class="message">{{ $t('BetSlip.status.error') }}</span>
            </div>
            <div v-if="errors.OTHER" class="errorMsg" >
              <span class="pd-icon pd-icon-dp-info"></span>
              <span class="message">{{errors.OTHER}}</span>
            </div>
          </div>
        </div> <!-- messages end -->
      </div>

      <div class="stake-line">
        <div class="stake">
          <money-input v-model="stake"
                       :id="1"
                       :inputType="'stake'"
                       :placeholder="placeholder.wager"
                       :disabled="currentBetSlipState>=1"
                       :focus="focus"
                       :perType="perType"
                       :minStake="minStake"
                       :maxStake="maxStake"
                       @dismissError="dismissError"
                       @setFocus="setFocus"
                       @hasError="hasError"
                       @input="storeInput"
          >
          </money-input>

        </div>

        <div v-show="!isLoggedIn" >
          <button class="btn primary-button primary-btn" @click="popLogIn()" >
                  <span>{{ $t('BetSlip.btn.msg.LogIn') }}</span>
          </button>
        </div>

        <div class="buttons" v-show="isLoggedIn"  >
          <span v-if="currentBetSlipState==0">
            <button class="btn primary-button primary-btn" @click="initPlaceBet()" v-if="!changed"
                    :disabled="disablePlaceBet()" :class="disablePlaceBet()" >
                <span class="btn-label">
                  <!--
                  <div v-show="gettingABTnR" class="loader-container">
                    <circle-loader></circle-loader>
                  </div>
                  -->
                  <div class="line1">
                    {{ $t('BetSlip.quick.btn.PlaceBet') }}
                  </div>
                  <div class="line2" >
                    <span>{{ $t('BetSlip.quick.btn.toWin') }}
                    </span><span v-show="winning>0"> ${{winning}}</span>
                  </div>
                </span>
            </button>

            <button v-else @click="acceptChanges()" class="btn btn_blue" >
              <span class="btn-label">
                <div class="line1">
                  {{ $t('BetSlip.quick.btn.Accept') }}
                </div>
                <div class="line2" v-if="false">
                  <span>{{ $t('BetSlip.quick.btn.toWin') }}
                  </span><span v-show="winning>0"> ${{winning}}</span>
                </div>
              </span>
            </button>

            <!--<v-btn @click="cancelDialog()" class="secondary">Cancel</v-btn>-->
          </span>


          <span v-if="currentBetSlipState==2 || currentBetSlipState==3" class="align-center loader-container">
            <!--<circle-loader></circle-loader>-->
            <circle-loader-with-counter :n="inRunningDelay"></circle-loader-with-counter>
            <!--<div>in {{inRunningDelay}}</div>-->
          </span>
          <span  v-if="currentBetSlipState==4" class="align-center">
            <div class="loading dots-loader">
              <dots-loader></dots-loader>
            </div>
          </span>



          <div v-if="currentBetSlipState==5" class="align-center">
            <div v-if="false && betSlipStatus.State==2">
              <button class="btn btn_blue" @click="dismissBetSlip()">
                {{ $t('BetSlip.quick.btn.OK') }}
              </button>
              <button class="btn btn_blue" @click="hideDialog()">
                {{ $t('BetSlip.quick.btn.Close') }}
              </button>
            </div>
            <div v-if="betSlipStatus.State==4">
              <button class="btn btn_blue" @click="dismissBetSlip()">
                {{ $t('BetSlip.quick.btn.TryAgain') }}
              </button>
            </div>
            <div v-if="false && betSlipStatus.State==5">
              <button class="btn btn_blue" @click="rejectBetSlip()">
                {{ $t('BetSlip.quick.btn.CancelBet') }}
              </button>
            </div>

            <div v-if="betSlipStatus.State==5">
              <div class="loading dots-loader">
                <!-- <circle-loader></circle-loader> -->
                <dots-loader></dots-loader>
              </div>
            </div>

          </div>

          <div v-if="currentBetSlipState==6" class="align-center" :class="{'inRefferal':inRefferal}">
            <button class="btn btn_white confirm-btn" @click="confirmBetSlip()">
              <div class="btn-label" >
                <div v-show="gracePeriod" class="loader-container loader_in_btn" >
                  <circle-loader-with-counter :n="gracePeriod"></circle-loader-with-counter>
                </div>
                <div class="line1">
                  <span v-if="inRefferal">{{ $t('BetSlip.placement.btn.CONFIRM.reffer') }}</span>
                  <span v-else>{{ $t('BetSlip.quick.btn.ConfirmBet') }}</span>
                </div>
                <div class="line2">
                  <span>{{ $t('BetSlip.quick.btn.toWin') }}</span> ${{winning}}
                </div>
              </div>
            </button>

            <button class="btn btn_blue" @click="rejectBetSlip()" v-if="false" >
              <span v-if="inRefferal" >{{ $t('BetSlip.placement.btn.CANCEL.reffer') }}</span>
              <span v-else >{{ $t('BetSlip.quick.btn.CancelBet') }}</span>
            </button>
          </div>




          <div v-if="currentBetSlipState==7" class="align-center">
            <button class="btn btn_blue" @click="dismissBetSlip()">
              <span>{{ $t('BetSlip.quick.btn.OK') }}</span>
            </button>
          </div>
          <div v-if="currentBetSlipState==8" class="align-center">
            <button class="btn btn_blue" @click="dismissBetSlip()">
              <span>{{ $t('BetSlip.quick.btn.OK') }}</span>
            </button>
          </div>
          <div v-if="currentBetSlipState==9" class="align-center">
            <button class="btn btn_blue" @click="dismissBetSlip()">
              <span>{{ $t('BetSlip.quick.btn.OK') }}</span>
            </button>
          </div>
        </div><!-- buttons end -->

        <div v-if="hasErrors" class="error-msg">
          <span class="pd-icon pd-icon-dp-info"></span>
          <span v-for="e in stakeErrors">
            <span v-if="e">{{ $t('BetSlip.stakeNreturn.error.' + e, {min:minStake, max:maxStake}) }}</span>
          </span>
          </div>

      </div><!-- stake line end -->



    </div>

    <!--<v-btn class="btn primary-button primary-btn" @click.native="confirmDialog()">confirmDialog</v-btn>-->
    <!--<v-btn @click.native="cancelDialog()" class="secondary">cancelDialog</v-btn>-->



    <div class="betPlacement" v-if="false && currentBetSlipState>1">
<!--
      <div v-if="currentBetSlipState==3" class="align-center">
        <div class="loading"><span>.</span><span>.</span><span>.</span></div>
      </div>
      <div v-if="currentBetSlipState==4" class="align-center">
        <div class="loading">Placing bet <span>.</span><span>.</span><span>.</span></div>
      </div>
      -->



      <div id="betSlipReceipt" v-if="false && (currentBetSlipState==5 || currentBetSlipState==6) && betPlacementResult && betSlipStatus.State!=4">
        <div v-if="betSlipStatus.State===2">
          Ref: {{betPlacementResult.ExternalReference}}<br>
          IDFOBetSlip: {{betPlacementResult.IDFOBetSlip}}<br>
          <hr>
        </div>
        <div v-for="bet in betPlacementResult.Bets" class="Bet">
          <span>{{ $t('BetSlip.betType.REGULAR.' + bet.IDFOBetType) }}</span><br>
          <div v-if="betPlacementResult.Bets.length>1">
            TotalStake: ${{bet.TotalStake}}<br>
            Potential Return: ${{(bet.PotentialReturn-bet.TotalStake).toFixed(2)}}<br>
            <hr>
          </div>
        </div>
        <div class="totals">
          TotalStake: ${{betPlacementResult.TotalStake}}<br>
          Potential Return: ${{attemptedBetPotentialReturn}}<br>
        </div>
      </div>


    </div>


    <!--{{betslipSelections}}    <br>-->
    <!--<br>betsNo: {{betsNo}}-->
    <!--<br>selection: {{selection}}-->
    <!--<br>betPlacementResult: {{betPlacementResult}}-->
    <!--<br>betslipSelectionId: {{id}}-->
    <!--<br>idfomarket: {{idfomarket}}-->
    <!--<br>currentBetSlipState: {{currentBetSlipState}}-->
    <!--<br>price: {{price}}-->
    <!--<br>priceLocal: {{priceLocal}}-->
    <!--<br>hcp: {{currenthandicapLocal}}-->
    <!--<br>changed: {{changed}}-->
    <!--<br>betSlipStatus: {{betSlipStatus}}-->
    <!--<br>errorType: {{errorType}}-->
    <!--<br>betPlacementResult: {{betPlacementResult}}-->
    <!--<br>activeBetSlip: {{activeBetSlip}}-->
    <!--<br>inRefferal: {{inRefferal}}-->

  </div>
</template>

<script>
  import Vue from 'vue'
  import Screen from '@/components/mixins/Screen'
  import store from '@/store'
  import priceFormat from '@/library/priceFormat'
  import betSlipSelection from './betslipSelection.vue'
  import BettingOffer from '@/components/mixins/BettingOffer'
  import circleLoaderWithCounter from '@/components/common/CircleLoaderWithCounter'
  import circleLoader from '@/components/common/CircleLoader'
  import dotsLoader from '@/components/common/DotsLoader'
  import moneyInput from './moneyInput.vue'
  import Icon from '@/components/common/Icon'

  export default {
    name: 'single-bet-slip',

    props: ['dialogSingleBetslip'],

    components: {
      betSlipSelection,
      circleLoaderWithCounter,
      circleLoader,
      dotsLoader,
      moneyInput,
      Icon
    },

    mixins: [
      BettingOffer,
      Screen
    ],

    data () {
      return {
        tab: 'REGULAR',
        perType: 'PerSelection',
        focus: [0],
        stateLimitToUpdate: 2,
        stakeErrors: {},
        multiSingles: false,
        stake_: null,
        winnings: null,
        betSlipState: {
          0: 'Idle',
          1: 'Waiting to confirm',
          2: 'Live CountDown',
          3: 'Spinner',
          4: 'In progress',
          5: 'Attempted',
          6: 'Acceptable',
          7: 'Canceled',
          8: 'TimedOut',
          9: 'Error'
        },
        betSlipPlacementState: {
          1: 'acceptable',
          2: 'accepted',
          3: 'reOffered',
          4: 'rejected',
          5: 'waiting'
        },
        betSlipStatus_: {},
        betPlacementResult_: {State: {}},
        errorId: null,
        errorMsg: null,
        errorType: null,
        errors: {
          GEN: ['-20402', '-20403', '-20404', '-20405', '-20406', '-20407', '-20408', '-20409', '-20410', '-20420', '-20425', '-20426', '-20427', '-20428', '-20429', '-20430', '-20435', '-20436', '-20437', '-20439', '-20450', '-20453', '-20456', '-20457', '-20460', '-20461', '-20477', '-20478', '20205', 'Invalid selections count'],
          ARC: ['-20412', '-20413', '-20414', '-20415', '-20416', '-20417', '-20418', '-20419'],
          CUSTOM: {
            '-20700': false,
            '-20451': 'INSUFFICIENT_FUNDS',
            '-20455': 'INTERRELATED'
          },
          OTHER: ''
        },
        showError: false,
        priceUp: false,
        priceDown: false,
        hcpUp: false,
        hcpDown: false
      }
    },

    computed: {
      inRefferal () {
        return store.getters['sbBetslipState/inRefferal']
      },
//      activeBetSlip () {
//        return store.getters['sbBetslipState/activeBetSlip']
//      },
      isLoggedIn () {
        return store.getters['isLoggedIn']
      },
      isGeolocated () {
        var isGeolocated = store.getters['getGeolocated']
        return typeof isGeolocated !== 'undefined' ? JSON.parse(isGeolocated) : false
      },
      geolocationMessage () {
        return store.getters['overlayState/getGeolocationMessage']
//        return {}
      },
      errorMsgLocalStorage () {
        return localStorage.getItem('geoError')
      },
      state () {
        return window.ctsautoconf.STATE
      },
      isOpenedFromWebView () {
        return store.getters['getIsOpenedFromWebView']
      },
      webViewAndMobile () {
        return store.getters['getWebViewAndMobile']
      },
      betPlacementResult () {
        return store.getters['sbBetslipState/betPlacementResult'].result
//        return this.betPlacementResult_
      },
      betSlipStatus () {
        return store.getters['sbBetslipState/betSlipStatus']
      },
      clearMarkings () {
        return store.getters['sbBetslipState/clearMarkings']
      },
      allowedBetTypesAndReturns () {
        return store.getters['sbBetslipState/allowedBetTypesAndReturns']
      },
      id () {
        var betslipSelectionIds = store.getters['sbBetslipState/betslipSelectionIds']
        return (betslipSelectionIds && betslipSelectionIds.length && betslipSelectionIds[0]) || false
      },
      selection () {
        return this.id ? store.getters['sbBetslipState/getStoredSelectionById'](this.id) : {}
      },
      idfomarket () {
        return store.getters['sbBetslipState/getIdfoMarketById'](this.id)
      },
      marketLive () {
        return this.id ? store.getters['sbBetslipState/getMarketById'](this.id) : {}
      },
      market () {
        return this.id && this.selection ? store.getters['sbBetslipState/getStoredMarketById'](this.id) : {}
      },
      liveSelection () {
        return this.id && this.selection ? store.getters['sbBetslipState/getSelectionById'](this.id) : {}
      },

      placeholder () {
        return {
          wager: this.$t('BetSlip.input.placeholder.wager'),
          return: this.$t('BetSlip.input.placeholder.return')
        }
      },
      betsNo () {
        return store.getters['sbBetslipState/selectionsNo']
      },
      selectionS () {
        return store.getters['sbBetslipState/singleBetSlip'] || {}
      },
      nr () {
//        return this.selection && this.selection.isclosed
        var selection = this.isLive ? !this.liveSelection : this.selection
        return selection && selection.idfobolifestate && selection.idfobolifestate === 'NR'
      },
      closed () {
//        return this.selection && this.selection.isclosed
        return this.isLive ? !this.marketLive : this.selection && this.selection.isclosed
      },
      suspended () {
//        return this.selection && !this.selection.isclosed && !this.selection.istradable
        return this.isLive ? this.marketLive && !this.marketLive.istradable : this.selection && !this.selection.isclosed && !this.selection.istradable
      },
      isNr () {
        return this.selection && this.selection.idfobolifestate && this.selection.idfobolifestate === 'NR'
      },
      isclosed () {
        return this.selection && this.selection.isclosed
      },
      issuspended () {
        return this.selection && !this.selection.isclosed && !this.selection.istradable
      },
      liveSelections () {
        return store.getters['sbBetslipState/liveSelections']
      },
      isLive () {
        return this.liveSelections.indexOf(this.id) >= 0
      },
      priceUp_ () {
        return this.selection.priceUp
      },
      priceDown_ () {
        return this.selection.priceDown
      },
      price () {
        var selection = this.liveSelection
        var price = selection && selection.price ? selection.price * 1 : ''
        if (this.currentBetSlipState > 1 && this.allowedBetTypesAndReturns && this.allowedBetTypesAndReturns.REGULAR && this.allowedBetTypesAndReturns.REGULAR.PotentialReturns) {
          var potentialReturn = this.allowedBetTypesAndReturns.REGULAR.PotentialReturns.PerSelection &&
            this.allowedBetTypesAndReturns.REGULAR.PotentialReturns.PerSelection[this.id] &&
            this.allowedBetTypesAndReturns.REGULAR.PotentialReturns.PerSelection[this.id].PotentialReturn
          price = parseFloat((potentialReturn * 1).toFixed(2))
        }
        return price
      },
      priceLocal () {
        return this.selection && this.selection.price
      },
      currenthandicap () {
        var selection = this.liveSelection
        var hcp = selection && selection.currenthandicap
        return hcp ? hcp * 1 : hcp
      },
      currenthandicapLocal () {
        var hcp = this.selection && this.selection.currenthandicap
        return hcp ? hcp * 1 : hcp
      },
      betTypeStakes () {
        return store.getters['sbBetslipState/betTypeStakes']
      },
      stake: {
        get: function () {
//          console.log('stake get')
          return (this.betTypeStakes && this.betTypeStakes[this.tab] && this.betTypeStakes[this.tab].PerSelection &&
            this.selection && this.selection.idfoselection &&
            this.betTypeStakes[this.tab].PerSelection[this.selection.idfoselection]) || this.stake_
        },
        set: function (val) {
//          console.log('stake set: ' + val)
          Vue.set(this.betTypeStakes[this.tab].PerSelection, this.selection.idfoselection, val)
        }
      },
      winning () {
//        console.log(this.stake + ': ' + typeof this.stake)
        if (this.stake !== '' && this.stake >= 0 && this.selection.price) {
          return (this.stake * (this.selection.price * 1 - 1)).toFixed(2)
        }
        return null
      },
      attemptedBetPotentialReturn () {
        var total = 0
        var betPlacementResult = this.betPlacementResult_
        if (betPlacementResult && betPlacementResult.Bets && betPlacementResult.Bets.length) {
          for (var i = 0; i < betPlacementResult.Bets.length; i++) {
            total += betPlacementResult.Bets[i].PotentialReturn - betPlacementResult.Bets[i].TotalStake
          }
        }
        return total.toFixed(2)
      },
      currentBetSlipState () {
        return store.getters['sbBetslipState/currentBetSlipState']
      },
      gracePeriod () {
        return store.getters['sbBetslipState/gracePeriod']
      },
      inRunningDelay () {
        return store.getters['sbBetslipState/inRunningDelay']
      },
      minStake () {
        return store.getters['sbBetslipState/minStake'].PerSelection
      },
      maxStake () {
        return store.getters['sbBetslipState/maxStake'].PerSelection
      },
      hasErrors () {
        return this.stakeErrors.stake || this.stakeErrors.winning
      },
      changed () {
        return !this.isclosed && !this.issuspended && !this.isNr &&
          (this.priceUp || this.priceDown || this.hcpUp || this.hcpDown)
      }
    },

    methods: {
      acceptChanges () {
        var self = this
        store.dispatch('sbBetslipState/resetBetSlipChanges').then(
          function () {
            self.priceUp = false
            self.priceDown = false
            self.hcpUp = false
            self.hcpDown = false
            //
            store.dispatch('sbBetslipState/updateBetSlip', !true)
            //
//            self.placeBet()
          }
        )
      },
      popLogIn () {
        store.dispatch('overlayState/activateLoginDialog')
      },
      confirmDialog () {
//        this.$emit('confirmDialog')
        this.addToBetSlip()
      },
      cancelDialog () {
//        console.log('cancelDialog')
//        this.$emit('cancelDialog')
        var self = this
        if (this.currentBetSlipState === 6 && this.betSlipStatus.State === 1) {
          this.rejectBetSlip().then(function () {
            self.dismissBetSlip()
//            store.dispatch('sbBetslipState/getAllowedBetTypesAndReturns')
            store.dispatch('sbBetslipState/toggleBetslipSelection', [this.selection])
            self.dialogSingleBetslip.resolve(false)
            store.dispatch('overlayState/deactivateSingleBetslip')
          })
        } else {
//          store.dispatch('sbBetslipState/getAllowedBetTypesAndReturns')
          store.dispatch('sbBetslipState/toggleBetslipSelection', [this.selection])
          this.dialogSingleBetslip.resolve(false)
          store.dispatch('overlayState/deactivateSingleBetslip')
        }
        store.commit('sbBetslipState/setActiveBetSlip', false)
      },
      hideDialog () {
//        this.$emit('hideDialog')
        this.dialogSingleBetslip.resolve('hide')
        store.dispatch('overlayState/deactivateSingleBetslip')
      },
      addToBetSlip () {
//        console.log('closeDialogSingleBetSlip ')
//        this.confirmDialog()
        this.dialogSingleBetslip.resolve(true)
        store.dispatch('overlayState/deactivateSingleBetslip')
      },
      formatSelectionName (selection) {
        return Array.isArray(selection.name) ? selection.name[0] : selection.name
      },
      formatSelectionPrice (selection) {
        return priceFormat.formatSelectionPrice(selection)
      },
      setCurrentBetSlipState (id) {
//        this.currentBetSlipState = id
        store.commit('sbBetslipState/setCurrentBetSlipState', id)
      },
      formatHandicap (selection) {
        var h = selection.currenthandicap && !isNaN(selection.currenthandicap) ? parseFloat(selection.currenthandicap) : ''
        if (h) {
          if (selection.hadvalue === 'D' || selection.hadvalue === 'A') {
            if (h) {
              h *= -1
            }
          }
          if (selection.hadvalue === 'H' || selection.hadvalue === 'D' || selection.hadvalue === 'A') {
            if (h > 0) {
              h = '+' + h
            }
          }
        }
        return h
      },
      dismissBetSlip () {
//        this.errorId = null
//        this.errorMsg = null
//        this.betPlacementResult_ = {}
        this.setBetPlacementResult({State: {}})
        this.setCurrentBetSlipState(0)
        this.handleBetPlacementError()
      },
      handleBetPlacementError () {
//        console.log('handleBetPlacementError: ' + this.errorId)
        switch (this.errorId) {
          case 'RECONFIRM_TNC_SB':
            store.dispatch('tncState/confirmTsAndCs4Area').then().catch(
              function (error) {
                console.log('confirmTsAndCs4Area error')
                console.log(error)
              }
            )
            break
          case 'NOT_LOGGED_IN':
            store.dispatch('overlayState/activateLoginDialog')
            break
        }
        this.errorMsg = false
        this.errorId = false
      },
      confirmBetSlip () {
        var self = this
        store.dispatch('sbBetslipState/confirmBetSlip').then(function (r) {
          self.handleBetPlacementErrorData(r)
        })
      },

      rejectBetSlip () {
        var self = this
        return store.dispatch('sbBetslipState/rejectBetSlip').then(function (r) {
          self.handleBetPlacementErrorData(r)
        })
      },
      createData () {
        var data = {
          id: [{IDFOBetType: 'S'}],
          tab: 'S1',
          isFastBet: this.id,
          betTypeStakes: {
            S1: {
              PerSelection: {}
            },
            PerTab: {
              S1: {}
            }
          },
          multiSingles: false,
          noStakes: !this.stake,
          minValuesNotMet: this.stake < this.minStake,
          maxValuesNotMet: this.stake > this.maxStake,
//          minReturnNotMet: this.minReturnNotMet
          winnings: this.winning ? this.winning * 1 : 0
        }
        data.betTypeStakes.S1.PerSelection[this.selection.idfoselection] = this.stake
        data.betTypeStakes.PerTab.S1 = this.stake
        return data
      },
      setBetPlacementResult (r) {
//        Vue.set(this, 'betPlacementResult_', r)
        this.betPlacementResult_ = r
      },
      initPlaceBet () {
        var data = this.createData()
        if (this.webViewAndMobile) {
          store.commit('overlayState/setMessageDialogMsg', {reason: 'native-app', persistent: true})
          store.dispatch('overlayState/activateMessageDialog')
        } else if (!this.isGeolocated && this.isOpenedFromWebView) {
          store.commit('overlayState/setMessageDialogMsg', {reason: 'native-failed-geolocation', persistent: true, fullscreen: false})
          store.dispatch('overlayState/activateMessageDialog')
        } else {
          this.placeBet(data)
        }
      },
      disablePlaceBet () {
        var disabled = this.gettingABTnR ||
//          this.showBetSlipChanged ||
          this.showError ||
          false
        //
//        console.log('disablePlaceBet: ' + disabled)
        var reason = []
        if (this.gettingABTnR) {
          reason.push('gettingABTnR')
        }
        if (this.showError) {
          reason.push('showError')
        }

        if (!this.isOpenedFromWebView && !this.webViewAndMobile) {
          if (this.isGeolocated) {
            return disabled ? reason.join('_') : disabled
          } else {
            return 'notGeoLocated'
          }
        }
      },
      placeBet (data) {
//        console.log('SingleBetSlip placeBet')
        var self = this
        self.showError = false
//        self.betPlacementResult_ = {}
        self.setBetPlacementResult({State: {}})
//        self.betSlipStatus = {}
//        var data = this.createData()
        this.setCurrentBetSlipState(4)
        store.dispatch('sbBetslipState/createBetSlip', data).then(
          function (betSlip) {
//            console.log(betSlip)
//            console.log(JSON.stringify(betSlip))
            store.dispatch('sbBetslipState/betSlipChecks', data).then(
              function (result) {
//                console.log(result)
//                store.dispatch('sbBetslipState/placeBetSlip', data).then(
                store.dispatch('sbBetslipState/startBetSlipPlacement', data).then(
                  function (result) {
//                    console.log('placeBetSlip result:')
//                    console.log(result)
                    if (result.exceptionType) {
                      self.errorId = 'UNKNOWN'
                      self.errorMsg = self.$t('BetSlip.placement.error.' + self.errorId)
                      self.setCurrentBetSlipState(9)
                    } else {
//                      self.betPlacementResult_ = result.result
                      self.setBetPlacementResult(result.result)
//                      self.betSlipStatus = result.result.Status
                      self.setCurrentBetSlipState(5)
                    }
                    self.handleBetPlacementErrorData(result)
                  }
                ).catch(function (error) {
                  console.log('Single Bet Slip Placement Error:')
                  console.log(error)
                  self.errorId = 'UNKNOWN'
                  self.errorMsg = self.$t('BetSlip.placement.error.' + self.errorId)
                  self.setCurrentBetSlipState(9)
                  self.showError = true
                })
              }
            ).catch(function (errors) {
              console.log('error in bet placement init')
              self.errorId = errors[0]
              self.errorMsg = self.$t('BetSlip.placement.error.' + errors[0])
              self.setCurrentBetSlipState(9)
              self.showError = true
            })
          }
        )
      },
      handleBetPlacementErrorData (r) {
//        console.log('handleBetPlacementErrorData FastBet')
        var self = this
        var errorId = false
        //
        if (r && r.exceptionType) {
          if (r.exceptionType === 'Com.Finsoft.Warp.Connecticut.SessionTimeoutException' ||
            r.exceptionType === 'Com.Finsoft.Warp.Connecticut.Services.UserNotLoggedInException' ||
            // r.exceptionType.indexOf('System.ServiceModel.FaultException') > -1 ||
            r.exceptionType === 'isLoggedOut') {
            errorId = 'SESSION_TIMEDOUT'
            clearTimeout(self.logOutTo)
            self.logOutTo = setTimeout(self.logOut, 1 * 1000)
          } else if (r.exceptionType.indexOf('System.ServiceModel.FaultException') > -1) {
            self.errors.OTHER = r.message
          }
        }
        if (self.betSlipStatus && (self.betSlipStatus.StatusText || self.betSlipStatus.StatusCode)) {
          var errT = this.checkErrorType()
          if (self.betSlipStatus.StatusText) {
            if (self.betSlipStatus.StatusText.indexOf('Invalid selections count') !== -1) {
              errT = 'GEN'
            }
            if (self.betSlipStatus.StatusText.indexOf('[MMaker-') !== -1) {
              errorId = 'UNKNOWN'
            }
            if (self.betSlipStatus.StatusText.indexOf('[MMaker-0002020088]') !== -1) {
              // [MMaker-0002020088] Internal service fault [LOG ID:51632351]
              errorId = 'UNKNOWN'
            }
            if (self.betSlipStatus.StatusText.indexOf('[MMaker-0002110088]') !== -1) {
              errorId = 'SESSION_TIMEDOUT'
            }
            if (self.betSlipStatus.StatusText.indexOf('[MMaker-0002130088]') !== -1) {
              errorId = 'WAGER_LIMIT'
            }
            if (self.betSlipStatus.StatusText.indexOf('[MMaker-0002090088]') !== -1) {
              errorId = 'TIME_LIMIT'
            }
            if ((self.betSlipStatus.StatusText && (self.betSlipStatus.StatusText.indexOf('[MMaker-0002190088]') !== -1 ||
              self.betSlipStatus.StatusText.indexOf('0002190088') !== -1 ||
              self.betSlipStatus.StatusText.indexOf('-20700') !== -1)) ||
              (self.betSlipStatus.StatusCode && self.betSlipStatus.StatusCode.indexOf('-20700') !== -1)) {
              // TODO
              errorId = 'DEPOSIT_THRESHOLD'
              errT = false
            }
          }
        }
        if (errorId) {
          self.errorId = errorId
          // self.errorMsg = self.$gettext('BetSlip.placement.error.' + self.errorId)
          // self.errorMsg = self.$gettextInterpolate(self.errorMsg, {uiView: self.isOpenedFromWebView ? '?uiView=true' : ''})
          self.errorMsg = self.$t('BetSlip.placement.error.' + self.errorId, {uiView: self.isOpenedFromWebView ? '?uiView=true' : ''})
          self.betSlipStatus.StatusText = self.errorMsg
        }
        if (errT) {
          self.errorId = errT
          self.errorType = errT
          // self.errorMsg = self.$gettext('BetSlip.placement.error.' + self.errorId + '.reason')
          // self.errorMsg = self.$gettextInterpolate(self.errorMsg, {uiView: self.isOpenedFromWebView ? '?uiView=true' : ''})
          self.errorMsg = self.$t('BetSlip.placement.error.' + self.errorId + '.reason', {uiView: self.isOpenedFromWebView ? '?uiView=true' : ''})
          self.betSlipStatus.StatusText = self.errorMsg
        }
      },

      checkErrorType (status) {
        var self = this
        var errT = null
        var codes = self.betSlipStatus.StatusCode ? self.betSlipStatus.StatusCode.split(/[, ]+/) : []
        if (codes.length) {
          codes.forEach(function (code) {
            if (self.errors.GEN.indexOf(code) > -1) {
              errT = errT || 'GEN'
            } else if (self.errors.ARC.indexOf(code) > -1) {
              errT = errT || 'ARC'
            } else if (self.errors.CUSTOM[code]) {
              errT = self.errors.CUSTOM[code]
            }
          })
        }
        return errT
      },
      dismissError (v) {
//        console.log('dismissError:' + v)
//        console.log(v)
//        console.log('---')
      },
      setFocus (id, val) {
//        this.focus[id] = val
        if (val) {
          Vue.set(this.focus, 0, id)
        } else {
          if (this.focus[0] === id) {
            Vue.set(this.focus, 0, 0)
          }
        }
      },
      killFocus (id) {
        this.focus[id] = !true
      },
      hasError (val) {
        Vue.set(this.stakeErrors, val[0], val[1])
      },
      storeInput (v) {
//        console.log('storeInput:' + v)
//        console.log(v)
//        console.log('---')
      },
      priceNum (price) {
        if (price) {
          if (typeof price === 'string') {
            price = parseFloat(price)
          }
          price = parseFloat(price.toFixed(2))
        }
        return price
      }
    },

    watch: {
      clearMarkings (clear) {
//        console.log('Watch: clearMarkings: ' + clear)
        var self = this
        if (clear) {
          self.priceUp = false
          self.priceDown = false
          self.hcpUp = false
          self.hcpDown = false
        }
      },
      priceLocal (newVal, oldVal) {
//        var doUpdate = false
        newVal = this.priceNum(newVal)
        oldVal = this.priceNum(oldVal)
//        console.log('WATCHER: selection.priceLocal: ' + oldVal + ' => ' + newVal)
        if (newVal > oldVal) {
//          doUpdate = true
          this.priceUp = true
          this.priceDown = false
        } else if (newVal < oldVal) {
//          doUpdate = true
          this.priceUp = false
          this.priceDown = true
        } else {
          this.priceUp = false
          this.priceDown = false
        }
//        if (doUpdate && this.currentBetSlipState < this.stateLimitToUpdate) {
//          store.dispatch('sbBetslipState/setBetSlipChange', {key: 'price', id: this.id})
//        }
      },
      price (newVal, oldVal) {
//        console.log('watcher price liveSelection:')
        if (this.tab === 'TEASER') {
          return
        }
        var doUpdate = false
//        console.log('WATCHER: selection.price_: ' + oldVal + ' => ' + newVal)
        newVal = this.priceNum(newVal)
        oldVal = this.priceNum(oldVal)
//        console.log('WATCHER: selection.price: ' + oldVal + ' => ' + newVal)
        if (newVal > oldVal) {
          doUpdate = true
        } else if (newVal < oldVal) {
          doUpdate = true
        }
        if (doUpdate && this.currentBetSlipState < this.stateLimitToUpdate) {
          Vue.set(this.selection, 'price', this.liveSelection.price)
          Vue.set(this.selection, 'currentpriceup', this.liveSelection.currentpriceup)
          Vue.set(this.selection, 'currentpricedown', this.liveSelection.currentpricedown)
        }
      },
      currenthandicapLocal (newVal, oldVal) {
//        console.log('WATCHER SBS: selection.currenthandicap: ' + oldVal + ' => ' + newVal)
        var self = this
//        var doUpdate = false
        if (newVal > oldVal) {
//          doUpdate = true
          self.hcpUp = true
          self.hcpDown = false
        } else if (newVal < oldVal) {
//          doUpdate = true
          self.hcpUp = false
          self.hcpDown = true
        } else {
          self.hcpUp = false
          self.hcpDown = false
        }
//        if (doUpdate && this.currentBetSlipState < this.stateLimitToUpdate) {
//          store.dispatch('sbBetslipState/setBetSlipChange', {key: 'currenthandicap', id: this.id})
//        }
      },
      currenthandicap (newVal, oldVal) {
//        console.log('WATCHER: selectionLIVE.currenthandicap: ' + oldVal + ' => ' + newVal)
        var doUpdate = false
        if (newVal > oldVal) {
          doUpdate = true
        }
        if (newVal < oldVal) {
          doUpdate = true
        }
        if (doUpdate && this.currentBetSlipState < this.stateLimitToUpdate) {
          Vue.set(this.selection, 'currenthandicap', this.liveSelection.currenthandicap)
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~@/css/config"
  .align-center {
    text-align: center
  }


  .dots-loader {
    .dots-loader {
      box-shadow: none;
      background-color: transparent;
      height: 50px;
      >>>span {
        bottom: 25px !important;
      }
    }
  }

  .columns {
    padding: 10px 12px;
    border-radius: 0 0 5px 5px;
    display: flex;
    align-items: center;
    clear: both;
  }
  .column-left{
    flex-grow: 0
    flex-basis: auto;
    margin-right: 12px
  }
  .column-right {
    display: block;
    flex: 1;
  }

  .selection-data {
    text-align: left;
    line-height: 1.3

    .market-name {
      text-transform: uppercase;
      color: #818e95;
      margin-top: 2px
    }
    .event-name {
    }
    .name {
      font-weight: bold;
      color: #06283b;
    }
  }

  .buttons {
    position: relative;
    min-height: 50px;
    text-align: center;
  }

  .btn {
    min-height: 50px;
    min-width: 48px;
    color: #fff;
    margin: 0;
    width: 100%;
    height: auto;
    font-weight: bold;
    padding: 0 5px;
  }

  .btn:disabled {
    opacity: 0.6;
  }

  .btn.primary-btn {
    background-color: #3fc369 !important;
    &:hover {
      background-color: #29974b !important
    }
  }
  .btn_blue {
    background: #1493ff !important;
    &:hover {
      background-color: #0d7fe1 !important
    }
  }
  .btn_white {
    background: #fff !important;
    color: #1493ff !important;
    border: 1px solid #CFD6DB
    &:hover {
      background-color: #fff !important
    }
  }
  .btn-label {
    line-height: 1.3;
  }
  .btn-label .line1 {
    font-size: 14px;
  }
  .btn-label .line2 {
    font-size: 12px;
    opacity: 0.8;
  }


  .confirm-btn {
    width: 100%;
    position: relative;
    .loader-container {
      position: absolute;
      right: 2px;
      top: 2px;
    }
  }

  .loader_in_btn {
    >>>.loader{
      border: 3px solid #CFD6DB;
      border-top: 3px solid #2396FC;
      border-top: 3px solid #2396FC;
      border-bottom: 3px solid #2396FC;
      border-radius: 50%;
      width: 25px;
      height: 25px;
      margin: 0
    }
    >>>.counter {
      width: 25px;
      height: 25px;
      font-size: 12px;
      line-height: 25px;
      margin-left: -13px;
    }
  }

  .betPlacement{
    padding: 0 10px
  }

  .errorMsg {
    padding: 10px;
    background-color: #FDECEC;
    color: #E54A4B;
    border: 1px solid #E54A4B;
    border-radius: 4px;
    font-size: 14px
    display: flex
    text-align: left
    line-height: 14px
    align-items: center
    justify-content: left
    margin-bottom: 5px
  }

    .msg.info {
      background-color: #e5f3ff !important;
      border-radius: 4px;
      color: #0f89f1 !important;
      border: 1px solid #4cadff;
      border-color: #4cadff !important;
      margin: 0  10px 5px 10px;
      padding: 10px 10px;
    }
  .msg.info.inRefferal {
      background-color: #FFF2E5 !important;
      border-radius: 4px;
      color: #EA913C !important;
      border: 1px solid #EA913C;
      border-color: #EA913C !important;
      margin: 0  10px 5px 10px;
      padding: 10px 10px;
      font-size: 14px
      line-height: 16px
    }



  #singleBetSlip {
    padding: 0px;
    background-color: #E9F5FF;

    .bsSelection {

      .selection-price {
        color: #1493ff;
        float: right;
        font-size: 14px;
        display: inline-block;
        .lock {
          display: none;
        }
      }

      &.isClosed .selection-price .price,
      &.isClosed.isSuspended .selection-price .price,
      &.isSuspended .selection-price .price {
        /*display: none;*/
        color: silver;
      }
      &.isClosed .selection-price .lock,
      &.isClosed.isSuspended .selection-price .lock,
      &.isSuspended .selection-price .lock {
        display: none;
        /*color: silver;*/
      }

      .stake {
        .money-input {
          background-color: #fff;
        }
        .error-msg {
          padding: 3px 0;
          background-color: #FDECEC;
          color: #E54A4B;
        }
      }
      .stake-line {
        text-align: center;
        padding: 0 10px 10px 10px
        > div {
          margin: 0
          display: inline-block
          width: 49%
          text-align: center
          vertical-align: top
          .btn {
            width: 100%
          }
        }
        .error-msg {
          padding: 10px 0px;
          background-color: #FDECEC;
          color: #E54A4B;
          display: flex;
          justify-content: left;
          width: 100%;
          text-align: left;
          margin-top: 5px
          align-items: center
          line-height: 12px
        }
      }
    }
  }

.pd-icon-dp-info 
  color red
.stake-line
  padding: 0 10px 10px 10px
  .pd-icon-dp-info 
    color red
.betPlacement
  h3
    padding: 0
    margin: 0 0 5px 0

  .messages
    padding: 10px
    // background: white
    // margin-bottom: 10px
    &.loader
      padding 0

  .not-geolocated {
    p {
      margin: 0px;
    }
    .verify {
      font-size: 12px;
      margin: 0px;
    }
    .pls-wait {
      margin: 0;
      color: #1F375B;
      text-transform: uppercase;
      font-size: 16px;
      font-weight: bold;
      line-height: 35px;
      text-align: center;
      height: 22px;
      margin-bottom: 5px;
    }
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/sports/betslip/SingleBetSlip.vue